// extracted by mini-css-extract-plugin
export var acceptButton = "_3t-6";
export var backdropBlur = "_3t-0";
export var fullContent = "_3t-5";
export var link = "_3t-7";
export var linkIcon = "_3t-8";
export var sideContent = "_3t-4";
export var sideImage = "_3t-3";
export var sideImageWrapper = "_3t-2";
export var splitLayout = "_3t-1";